import React, { useRef } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import { NeonButton } from './ui/NeonButton';
import { Check, Download, Smartphone } from 'lucide-react';
export function ProductEmbed() {
  const containerRef = useRef<HTMLDivElement>(null);
  const {
    scrollYProgress
  } = useScroll({
    target: containerRef,
    offset: ['start center', 'end center']
  });
  return <section id="comprar" className="py-24 bg-[#0A0A0A] border-y border-white/5 relative" ref={containerRef} data-id="element-151">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 relative" data-id="element-152">
        {/* Vertical Line Extension from Dolores Section */}
        <div className="absolute left-4 sm:left-6 top-0 w-1 h-24 bg-gradient-to-b from-[#FF3535] to-transparent" style={{
        boxShadow: '0 0 10px #FF3535, 0 0 20px rgba(255, 53, 53, 0.5)'
      }} data-id="element-153" />

        {/* Container with ambient neon glow */}
        <div className="relative" data-id="element-154">
          {/* Ambient Neon Glow - Behind the container */}
          <motion.div className="absolute inset-0 rounded-3xl pointer-events-none" style={{
          zIndex: 0,
          transform: 'translate(0, 0)',
          opacity: useTransform(scrollYProgress, [0, 0.2, 0.8, 1], [0, 1, 1, 0.7]),
          boxShadow: useTransform(scrollYProgress, [0, 1], ['0 0 0px rgba(255, 107, 53, 0)', '0 0 60px rgba(255, 107, 53, 0.4), 0 0 100px rgba(255, 107, 53, 0.2), 0 0 140px rgba(255, 107, 53, 0.1)'])
        }} data-id="element-155" />

          <div className="bg-[#121212] rounded-3xl overflow-hidden border border-white/10 shadow-2xl relative" style={{
          zIndex: 1
        }} data-id="element-156">
            <div className="grid md:grid-cols-2 gap-0 relative" data-id="element-157">
              {/* Product Image Placeholder */}
              <div className="bg-gradient-to-br from-gray-800 to-black p-12 flex items-center justify-center relative min-h-[300px]" data-id="element-158">
                <div className="relative w-full aspect-[3/4] bg-[#0A0A0A] rounded-lg border border-white/10 shadow-2xl transform rotate-[-5deg] hover:rotate-0 transition-transform duration-500" data-id="element-159">
                  <div className="absolute inset-0 flex flex-col p-4 opacity-50" data-id="element-160">
                    <div className="w-full h-4 bg-white/10 mb-4 rounded" data-id="element-161"></div>
                    <div className="w-2/3 h-4 bg-white/10 mb-8 rounded" data-id="element-162"></div>
                    <div className="grid grid-cols-7 gap-2" data-id="element-163">
                      {[...Array(28)].map((_, i) => <div key={i} className="aspect-square border border-white/10 rounded-sm" data-id="element-164"></div>)}
                    </div>
                  </div>
                  <div className="absolute inset-0 flex items-center justify-center" data-id="element-165">
                    <span className="text-2xl font-black text-white/20 uppercase -rotate-45" data-id="element-166">
                      Enfocado
                    </span>
                  </div>
                </div>
              </div>

              {/* Product Details */}
              <div className="p-8 md:p-12 flex flex-col justify-center" data-id="element-167">
                <div className="mb-2 text-[#FF6B35] font-bold uppercase tracking-wider text-sm" data-id="element-168">
                  Oferta Limitada
                </div>
                <h2 className="text-3xl font-black text-white mb-4" data-id="element-169">
                  Sistema Enfocado v2.0
                </h2>

                <div className="flex items-baseline gap-3 mb-6" data-id="element-170">
                  <span className="text-4xl font-bold text-white" data-id="element-171">$17.99</span>
                  <span className="text-xl text-gray-500 line-through" data-id="element-172">
                    $57.99
                  </span>
                  <span className="text-xs bg-[#FF6B35]/20 text-[#FF6B35] px-2 py-1 rounded font-bold uppercase" data-id="element-173">
                    69% OFF
                  </span>
                </div>

                <p className="text-gray-400 mb-2 text-sm leading-relaxed" data-id="element-174">
                  El sistema completo para recuperar tu enfoque. Descarga
                  inmediata. Sin envíos, sin esperas.
                </p>

                <p className="text-xs text-gray-500 mb-8" data-id="element-175">
                  * Precio en USD. Se mostrará en tu moneda local al procesar el
                  pago.
                </p>

                <a href="https://sistemaenfocado.com" target="_blank" rel="noopener noreferrer" className="block" data-id="element-176">
                  <NeonButton fullWidth className="mb-6" data-id="element-177">
                    Obtener acceso instantáneo
                  </NeonButton>
                </a>

                <div className="space-y-3" data-id="element-178">
                  <div className="flex items-center text-xs text-gray-500" data-id="element-179">
                    <Download size={14} className="mr-2 text-[#FF6B35]" data-id="element-180" />
                    Envío digital inmediato
                  </div>
                  <div className="flex items-center text-xs text-gray-500" data-id="element-181">
                    <Check size={14} className="mr-2 text-[#FF6B35]" data-id="element-182" />
                    Descargable e imprimible
                  </div>
                  <div className="flex items-center text-xs text-gray-500" data-id="element-183">
                    <Smartphone size={14} className="mr-2 text-[#FF6B35]" data-id="element-184" />
                    Compatible con iOS/Android
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}